import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { PasswordMeter } from '../../assets/PasswordMeter';
import COLOURS from '../../constants/colour';

type Props = {
  strong: boolean;
  passwordMatch?: boolean;
};

const useStyles = makeStyles({
  root: {
    marginBottom: '35px',
    zIndex: 0,
  },
  message: {
    fontSize: '14px',
    textAlign: 'left',
    letterSpacing: '-0.12px',
    marginTop: '7px',
  },
  text: {
    fontSize: '12px',
    textAlign: 'left',
    letterSpacing: '-0.12px',
    marginTop: '10px',
    color: COLOURS.PortalGrey,

    '& a': {
      color: COLOURS.LightPurple,
      textDecoration: 'underline',
    },

    '& span': {
      color: COLOURS.Orange,
    },
  },
});

export const PasswordStrengthIndicator: React.FC<Props> = ({ strong, passwordMatch }) => {
  const classes = useStyles();
  const [message, setMessage] = useState('');
  const [textColor, setTextColor] = useState('');

  useEffect(() => {
    if (strong) {
      if (typeof passwordMatch === 'undefined') {
        setTextColor(COLOURS.LightGreen);
        setMessage('This password is strong.');
      } else if (passwordMatch) {
        setTextColor(COLOURS.LightGreen);
        setMessage('Passwords match!');
      } else if (!passwordMatch) {
        setTextColor(COLOURS.Orange);
        setMessage('Passwords do not match.');
      }
    } else {
      setTextColor(COLOURS.Orange);
      setMessage('Password must be stronger.*');
    }
  }, [strong, passwordMatch]);

  return (
    <div className={classes.root}>
      <PasswordMeter strong={strong} />
      <div className={classes.message} style={{ color: textColor }}>
        {message}
      </div>
      {!strong && (
        <div className={classes.text}>
          <span>*</span> Any combination of{' '}
          <a href="https://www.useapassphrase.com/" target="_blank" rel="noopener noreferrer">
            three random words
          </a>{' '}
          is one of the strongest passwords you can have.
        </div>
      )}
    </div>
  );
};
